import React from 'react'
import { Oval } from 'react-loader-spinner'

function LoadingComponent() {
    return (
        <div className='flex items-center justify-center pt-10'>
            <Oval color='black' secondaryColor='black' strokeWidth={5} width={20} height={20} />
        </div>
    )
}

export default LoadingComponent